import types from '../types'
import Action from '../../types/Action'

const initialState = {
    cities: {
        loading: false,
        error: false,
        success: false,
        data: []
    },
    states: {
        loading: false,
        error: false,
        success: false,
        data: []
    },
    counties: {
        loading: false,
        error: false,
        success: false,
        data: []
    }
}

const locationReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case types.GET_CITIES_REQUESTED: {
            return {
                ...state,
                cities: {
                    loading: true,
                    error: false,
                    success: false,
                    data: []
                }
            }
        }
        case types.GET_CITIES_FULFILLED: {
            return {
                ...state,
                cities: {
                    ...state.cities,
                    loading: false,
                    success: true,
                    data: action.payload
                }
            }
        }
        case types.GET_CITIES_REJECTED: {
            return {
                ...state,
                cities: {
                    ...state.cities,
                    loading: false,
                    error: action.payload
                }
            }
        }
        case types.GET_STATES_REQUESTED: {
            return {
                ...state,
                states: {
                    loading: true,
                    error: false,
                    success: false,
                    data: []
                }
            }
        }
        case types.GET_STATES_FULFILLED: {
            return {
                ...state,
                states: {
                    ...state.cities,
                    loading: false,
                    success: true,
                    data: action.payload
                }
            }
        }
        case types.GET_STATES_REJECTED: {
            return {
                ...state,
                states: {
                    ...state.cities,
                    loading: false,
                    error: action.payload
                }
            }
        }
        case types.GET_COUNTIES_REQUESTED: {
            return {
                ...state,
                counties: {
                    loading: true,
                    error: false,
                    success: false,
                    data: []
                }
            }
        }
        case types.GET_COUNTIES_FULFILLED: {
            return {
                ...state,
                counties: {
                    ...state.counties,
                    loading: false,
                    success: true,
                    data: action.payload
                }
            }
        }
        case types.GET_COUNTIES_REJECTED: {
            return {
                ...state,
                counties: {
                    ...state.counties,
                    loading: false,
                    error: action.payload
                }
            }
        }
        default:
            return state
    }
}

export default locationReducer